import { createSlice, createAsyncThunk } from "@reduxjs/toolkit"
import { setMessage } from "./message"
import EventBus from "../../utils/EventBus"
import ROLEAPI from "../../Api/role"

export const fetchRoles = createAsyncThunk("roles/fetchRoles", async (params, thunkAPI) => {
  try {
    const response = await ROLEAPI.getRoles(params)
     return response.data   
  } catch (error) {
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      EventBus.dispatch("logout");
    }
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    thunkAPI.dispatch(setMessage(message));
    return thunkAPI.rejectWithValue(message)
  }
})

export const createRole = createAsyncThunk("roles/createRole", async (formData, thunkAPI) => {
  try {
    const response = await ROLEAPI.addRole(formData)
    const message=(response.message)

    thunkAPI.dispatch(setMessage(message))

    return response
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    thunkAPI.dispatch(setMessage(message));
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      EventBus.dispatch("logout");
    }
    return thunkAPI.rejectWithValue(message)
  }
})

export const updateRole = createAsyncThunk("roles/updateRole", async ({r_id, formData}, thunkAPI) => {
  try {
    const response = await ROLEAPI.updateRole(r_id, formData)
    const message=(response.message)
    
    thunkAPI.dispatch(setMessage(message))

    return response
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    thunkAPI.dispatch(setMessage(message))
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      EventBus.dispatch("logout");
    }
    return thunkAPI.rejectWithValue(message)
  }
})

export const deleteRole = createAsyncThunk("roles/deleteRole", async (id, thunkAPI) => {
  try {
    const response = await ROLEAPI.deleteRole(id)
    const message=(response.data.message)
    thunkAPI.dispatch(setMessage(message))
    return id
  } catch (error) {
    const message = (error.response && error.response.data && error.response.data.message) || error.message || error.toString()
    thunkAPI.dispatch(setMessage(message));
    if (error.response && (error.response.status === 401 || error.response.status === 403)) {
      EventBus.dispatch("logout");
    }
    return thunkAPI.rejectWithValue(message)
  }
})

const roleSlice = createSlice({
  name: "roles",
  initialState: {
    roles: [],
    totalCount: 0
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchRoles.fulfilled, (state, action) => {
        state.roles = action.payload.data
        state.totalCount = action.payload.totalCount
      })
      .addCase(createRole.fulfilled, (state, action) => {
        state.roles.push(action.payload.data)
      })
       .addCase(updateRole.fulfilled, (state, action) => {
        const {
          arg: { r_id },
        } = action.meta;
        if (r_id) {
          state.roles = state.roles.map((item) =>
            item._id === r_id ? action.payload.data : item
          );
        };
      })
       .addCase(deleteRole.fulfilled, (state, action) => {
          state.roles = state.roles.filter((role) => role._id !== action.payload)
     })
  },  
})

const { reducer } = roleSlice
export default reducer
